// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/integrations/voucher_groups" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsVoucherGroups } from "./constants";
import type { IntegrationsVoucherGroupsParams, IntegrationsVoucherGroupsResult } from "./types";
import { isIntegrationsVoucherGroupsResult } from "./validators";

export const getDataTableIntegrationsVoucherGroups = reactQueryTableFetcherAdapter(
  integrationsVoucherGroups,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0, sortdir, sortby }: IntegrationsVoucherGroupsParams
  ): Promise<IntegrationsVoucherGroupsResult> => {
    return fetch(
      "/integrations/voucher_groups",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isIntegrationsVoucherGroupsResult
);
